/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIntegrationsConfig200ResponseEmailForwarding } from './GetIntegrationsConfig200ResponseEmailForwarding';
import {
    GetIntegrationsConfig200ResponseEmailForwardingFromJSON,
    GetIntegrationsConfig200ResponseEmailForwardingFromJSONTyped,
    GetIntegrationsConfig200ResponseEmailForwardingToJSON,
    GetIntegrationsConfig200ResponseEmailForwardingToJSONTyped,
} from './GetIntegrationsConfig200ResponseEmailForwarding';
import type { GetIntegrationsConfig200ResponseAutotask } from './GetIntegrationsConfig200ResponseAutotask';
import {
    GetIntegrationsConfig200ResponseAutotaskFromJSON,
    GetIntegrationsConfig200ResponseAutotaskFromJSONTyped,
    GetIntegrationsConfig200ResponseAutotaskToJSON,
    GetIntegrationsConfig200ResponseAutotaskToJSONTyped,
} from './GetIntegrationsConfig200ResponseAutotask';
import type { GetIntegrationsConfig200ResponseNinjaOne } from './GetIntegrationsConfig200ResponseNinjaOne';
import {
    GetIntegrationsConfig200ResponseNinjaOneFromJSON,
    GetIntegrationsConfig200ResponseNinjaOneFromJSONTyped,
    GetIntegrationsConfig200ResponseNinjaOneToJSON,
    GetIntegrationsConfig200ResponseNinjaOneToJSONTyped,
} from './GetIntegrationsConfig200ResponseNinjaOne';
import type { GetIntegrationsConfig200ResponseTehtris } from './GetIntegrationsConfig200ResponseTehtris';
import {
    GetIntegrationsConfig200ResponseTehtrisFromJSON,
    GetIntegrationsConfig200ResponseTehtrisFromJSONTyped,
    GetIntegrationsConfig200ResponseTehtrisToJSON,
    GetIntegrationsConfig200ResponseTehtrisToJSONTyped,
} from './GetIntegrationsConfig200ResponseTehtris';

/**
 * 
 * @export
 * @interface GetIntegrationsConfig200Response
 */
export interface GetIntegrationsConfig200Response {
    /**
     * 
     */
    tehtris?: GetIntegrationsConfig200ResponseTehtris;
    /**
     * 
     */
    autotask?: GetIntegrationsConfig200ResponseAutotask;
    /**
     * 
     */
    ninjaOne?: GetIntegrationsConfig200ResponseNinjaOne;
    /**
     * 
     */
    emailForwarding?: GetIntegrationsConfig200ResponseEmailForwarding;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200Response interface.
 */
export function instanceOfGetIntegrationsConfig200Response(value: object): value is GetIntegrationsConfig200Response {
    return true;
}

export function GetIntegrationsConfig200ResponseFromJSON(json: any): GetIntegrationsConfig200Response {
    return GetIntegrationsConfig200ResponseFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'tehtris': json['tehtris'] == null ? undefined : GetIntegrationsConfig200ResponseTehtrisFromJSON(json['tehtris']),
        'autotask': json['autotask'] == null ? undefined : GetIntegrationsConfig200ResponseAutotaskFromJSON(json['autotask']),
        'ninjaOne': json['ninjaOne'] == null ? undefined : GetIntegrationsConfig200ResponseNinjaOneFromJSON(json['ninjaOne']),
        'emailForwarding': json['emailForwarding'] == null ? undefined : GetIntegrationsConfig200ResponseEmailForwardingFromJSON(json['emailForwarding']),
    };
}

export function GetIntegrationsConfig200ResponseToJSON(json: any): GetIntegrationsConfig200Response {
    return GetIntegrationsConfig200ResponseToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseToJSONTyped(value?: GetIntegrationsConfig200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tehtris': GetIntegrationsConfig200ResponseTehtrisToJSON(value['tehtris']),
        'autotask': GetIntegrationsConfig200ResponseAutotaskToJSON(value['autotask']),
        'ninjaOne': GetIntegrationsConfig200ResponseNinjaOneToJSON(value['ninjaOne']),
        'emailForwarding': GetIntegrationsConfig200ResponseEmailForwardingToJSON(value['emailForwarding']),
    };
}

